import type { MouseEvent } from "react";
import { noop } from "lodash";
import { H6, RadioButton } from "orcs-design-system";
import {
  filterTypeLabels,
  filterTypes,
} from "../../../pages/SearchPage/SearchPage.config";

type FilterTypeRadioGroupProps = {
  type: string | undefined;
  enablePositionBackedVacancies: boolean | undefined;
  onNavigate: (searchType: string) => (e: MouseEvent) => void;
};

const FilterTypeRadioGroup = ({
  type,
  enablePositionBackedVacancies,
  onNavigate,
}: FilterTypeRadioGroupProps) => (
  <>
    <H6 fontWeight="bold" mb="s">
      What are you looking for?
    </H6>
    <RadioButton
      name="search-filter-btn"
      label={filterTypeLabels.ALL}
      checked={type === filterTypes.ALL}
      onChange={noop}
      onClick={onNavigate(filterTypes.ALL)}
    />
    <RadioButton
      name="search-filter-btn"
      label={filterTypeLabels.PEOPLE}
      checked={type === filterTypes.PEOPLE}
      onChange={noop}
      onClick={onNavigate(filterTypes.PEOPLE)}
    />
    {!!enablePositionBackedVacancies && (
      <RadioButton
        name="search-filter-btn"
        label={filterTypeLabels.POSITIONS}
        checked={type === filterTypes.POSITIONS}
        onChange={noop}
        onClick={onNavigate(filterTypes.POSITIONS)}
      />
    )}
    <RadioButton
      name="search-filter-btn"
      label={filterTypeLabels.TEAM}
      checked={type === filterTypes.TEAMS}
      onChange={noop}
      onClick={onNavigate(filterTypes.TEAMS)}
    />
    <RadioButton
      name="search-filter-btn"
      label={filterTypeLabels.TAGS}
      checked={type === filterTypes.TAGS}
      onChange={noop}
      onClick={onNavigate(filterTypes.TAGS)}
    />
  </>
);

export default FilterTypeRadioGroup;
